<template>
    <div id="form-signup">
        <div id="userForm">
            <h6 class="">{{title}}</h6>
			<hr class="c-hr" />

            <b-row class="p-0">
                <b-col>
                    <b-form-group label="* Nombre">
                        <b-form-input type="text" v-model="form.nombre" required />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="* Apellidos">
                        <b-form-input type="text" v-model="form.apellidos" required />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="p-0">
                <b-col>
                    <b-form-group label="* Correo electrónico">
                        <b-form-input type="email" v-model="form.email" required />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="* Teléfono">
                        <b-form-input id="formTelefono" v-model="form.telefono" required />
                        <b-form-checkbox id="telefono-es-sky" name="telefono-es-sky" v-model="form.telefono_is_skycel" value="1" unchecked-value="0" class="mt-2" v-if="!isLogged">
                            Mi número es SKYCEL
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="p-0">
                <b-col>
                    <b-form-group label="* Contraseña">
                        <b-form-input type="password" v-model="form.password" required />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="* Confirmar contraseña" v-if="!!form.password">
                        <b-form-input type="password" v-model="form.password_confirm" required />
                    </b-form-group>
                </b-col>
            </b-row>

        </div>

        <div id="userAddress">

            <h6 class="">Datos de tu domicilio</h6>
			<hr class="c-hr" />

            <b-row class="p-0">

                <b-col>
                    <b-form-group label="* Estado">
                        <b-form-input type="text" v-model="form.estado" required />
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group label="* Ciudad">
                        <b-form-input type="text" v-model="form.ciudad" required />
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group label="* Colonia">
                        <b-form-input type="text" v-model="form.colonia" required />
                    </b-form-group>
                </b-col>

            </b-row>
            
            <b-row class="p-0">

                <b-col cols="6">
                    <b-form-group label="* Calle">
                        <b-form-input type="text" v-model="form.calle" required />
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group label="* Número">
                        <b-form-input type="text" v-model="form.numero" required />
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group label="* CP">
                        <b-form-input type="text" v-model="form.codigo_postal" required />
                    </b-form-group>
                </b-col>

            </b-row>

            <b-form-group>
                <b-form-checkbox id="form-facturacion" name="form-facturacion"
                    v-model="form.facturacion" value="Si" unchecked-value="No">
                    Facturación
                </b-form-checkbox>
            </b-form-group>

        </div>

        <div id="userBilling" v-if="form.facturacion == 'Si'">

            <h6 class="">Datos de facturación</h6>
			<hr class="c-hr" />

            <b-form-group label="* Persona">
                <b-form-select type="text" v-model="form.persona" required>
                    <b-form-select-option v-for="m in ['Física', 'Moral']" :key="m" :value="m">
                        {{ m }}
                    </b-form-select-option>
                </b-form-select>
            </b-form-group>

            <b-form-group label="* R. F. C.">
                <b-form-input type="text" v-model="form.rfc" required />
            </b-form-group>

            <b-form-group label="* Razón social">
                <b-form-input type="text" v-model="form.razonsocial" required />
            </b-form-group>

        </div>
    </div>
</template>

<script>
    import _ from 'lodash'
    import mobiscroll from '@mobiscroll/javascript'
    import { mapGetters } from 'vuex'

    export default {
        name: 'formSignup',
        props: {
            title: {
                type: String,
                default: 'Crea tu cuenta'
            },
            value: {
                type: Object
            }
        },
        data: () => {
            return {
                form: {},
                mobi: {
                    formTelefono: null,
                }
            }
        },
        computed: {
            ...mapGetters(['isLogged', 'getUser'])
        },
        methods: {
            loadUpMobiPhone() {
                let id = 'formTelefono';
                this.mobi.formTelefono = mobiscroll.numpad('#' + id, {
                    // display: 'bottom',
                    lang: 'es',
                    fill: 'ltr',
                    template: '(ddd) ddd-dddd',
                    // allowLeadingZero: true,
                    validate: function (event, inst) {
                        if (inst.isVisible()) {
                            // Display the formatted value
                            inst._markup[0].querySelector('.mbsc-np-dsp').innerHTML = inst.settings.formatValue(event.values, event.variables, inst) || '&nbsp;';
                        }
                        return {
                            // Set the set button invalid until 10 chars filled
                            invalid: event.values.length != 10
                        };
                    },
                    formatValue: function (numbers, variables, inst) {
                        // Specify how the value will be formatted
                        return (numbers.length > 2 ? '(' : '')
                            + numbers.slice(0, 3).join('')
                            + (numbers.length > 2 ? ') ' : '')
                            + numbers.slice(3, 6).join('')
                            + (numbers.length > 5 ? '-' : '')
                            + numbers.slice(6, 10).join('');
                    },
                    parseValue: function (v, i) {
                        if (v) {
                            return v.replace('(', '').replace(') ', '').replace('-', '');
                        }
                    }
                });
            },
            reviewValues(mode){
                if(JSON.stringify(this.form) != JSON.stringify(this.value)){
                    switch(mode){
                        case 'emit':
                            this.$emit('input', this.form)
                            break;
                        default:
                            this.form = _.clone(this.value)
                            break;
                    }
                } else {
                    console.log('same!')
                }
            }
        },
        mounted(){
            if(!this.value && !this.isLogged){
                this.$emit('input', {
                    nombre: null,
                    apellidos: null,
                    email: null,
                    telefono: null,
                    telefono_is_skycel: 0,
                    password: null,
                    token: null,
                    created: null,
                    estatus: null,
                    modificado: null,

                    estado: null,
                    ciudad: null,
                    colonia: null,
                    calle: null,
                    numero: null,
                    codigo_postal: null,

                    persona: null,
                    rfc: null,
                    razonsocial: null,
                    facturacion: 'No'
                })
            } else if(!this.value){
                this.$emit('input', this.getUser)
            }
            setTimeout(this.loadUpMobiPhone, 50)
        },
        updated(){
            this.reviewValues('emit')
        },
        watch: {
            value(){
                this.reviewValues()
            }
        }
    }
</script>